import { commonjsGlobal as t } from "./index61.js";
import { __exports as o } from "./index80.js";
import "./index140.js";
import "./index141.js";
import { __exports as a } from "./index142.js";
import { __exports as u } from "./index143.js";
var s = t && t.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(o, "__esModule", { value: !0 });
o.default = n;
var f = s(a), _ = u, m = /<(![a-zA-Z\s]+)>/;
function n(r) {
  if (typeof r != "string")
    throw new TypeError("First argument must be a string");
  if (!r)
    return [];
  var e = m.exec(r), i = e ? e[1] : void 0;
  return (0, _.formatDOM)((0, f.default)(r), null, i);
}
